import { Link } from "react-router-dom";
import { videos, categories } from "@/mocks/videos";
import VideoCard from "@/components/base/VideoCard";

export default function LatestUpdates() {
  const latestAll = Object.values(videos).flat().slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="最新更新">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新上线的热门内容</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {categories.slice(0, 5).map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="px-3 py-1.5 text-xs rounded-full bg-background-50 border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {cat.name}
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {latestAll.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}